var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 21.3281L25.7031 34.4531C24.5312 35.625 22.5 34.8046 22.5 33.125V25.625H11.875C10.8359 25.625 10 24.789 10 23.75V16.25C10 15.2109 10.8359 14.375 11.875 14.375H22.5V6.87495C22.5 5.20308 24.5234 4.37495 25.7031 5.54683L38.8281 18.6718C39.5547 19.4062 39.5547 20.5937 38.8281 21.3281ZM15 34.0625V30.9375C15 30.4218 14.5781 30 14.0625 30H7.5C6.11719 30 5 28.8828 5 27.5V12.5C5 11.1171 6.11719 9.99995 7.5 9.99995H14.0625C14.5781 9.99995 15 9.57808 15 9.06245V5.93745C15 5.42183 14.5781 4.99995 14.0625 4.99995H7.5C3.35938 4.99995 0 8.35933 0 12.5V27.5C0 31.6406 3.35938 35 7.5 35H14.0625C14.5781 35 15 34.5781 15 34.0625Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.db1a95cd3096c63b3b5ce9d9496b9157.svg";
export { ForwardRef as ReactComponent };